import { createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

import { UserRoles } from "core/enum/user-roles.enum";
import { TDecodedToken, TUser } from "core/models/auth.model";
import { getUser, loginCallback } from "core/services/auth/auth";
import { setUser } from "./auth.slice";

export const handleLoginCallback = createAsyncThunk(
  "auth/loginCallback",
  async (_, { dispatch }) => {
    await loginCallback();

    const user = await getUser();

    if (!user) {
      throw new Error("User not found");
    }

    const decoded = jwtDecode<TDecodedToken>(user.access_token);

    let roles: UserRoles[] = [];

    if (decoded.role) {
      roles = Array.isArray(decoded.role) ? decoded.role : [decoded.role];
    }

    if (roles.length === 0) {
      roles.push(UserRoles.NormalUser);
    }

    const userIdentity: TUser = {
      id: Number(decoded.sub),
      username: decoded.name ?? decoded.phone_number ?? "",
      name: decoded.name ?? "",
      firstName: decoded.first_name ?? "",
      lastName: decoded.last_name ?? "",
      phoneNumber: decoded.phone_number ?? "",
      nationalCode: decoded.national_code ?? "",
      roles,
      authTime: decoded.auth_time ?? 0,
    };

    dispatch(setUser(userIdentity));

    return true;
  },
);
